import React from 'react'
import { ReactComponent as BookingIcon } from './home-booking.svg'
import { ReactComponent as InstructionIcon } from './home-instruction.svg'
import { ReactComponent as MoreIcon } from './home-more.svg'
import { ReactComponent as StationIcon } from './home-station2.svg'
import { ReactComponent as HomeCool } from './home-cool.svg'
import { ReactComponent as HomeAdvise } from './home-advise.svg'
import { ReactComponent as HomeRescue } from './home-rescue.svg'
import { ReactComponent as BHTNDSIcon } from './BHTNDS.svg'
import { ReactComponent as BagIcon } from './bags.svg'
import { ReactComponent as LockIcon } from './locks.svg'
import { ReactComponent as ShieldIcon } from './shields.svg'
import { ReactComponent as UserIcon } from './userPrs.svg'
import { ReactComponent as BookingHistoryIcon } from './bookings.svg'
import { ReactComponent as ContractIcon } from './contract.svg'
import { ReactComponent as VihcleIcon } from './vhicles.svg'
import { ReactComponent as FileIcon } from './instruct.svg'
import { ReactComponent as CustomerCareIcon } from './cares.svg'
import { ReactComponent as BackUpIcon } from './backups.svg'
import { ReactComponent as Feed } from './feeds.svg'
import { ReactComponent as Pay } from './pays.svg'
import { ReactComponent as VihcleIcon2 } from './home-vihcle.svg'
import { ReactComponent as InspectionFeeIcon } from './fee_inspection_icon.svg'
import { ReactComponent as RoadFeeIcon } from './fee_road_icon.svg'
import { ReactComponent as InsuranceIcon } from './insurance_icon.svg'
import { ReactComponent as NotifiBlueIcon } from './notifi-blue.svg'
import { ReactComponent as CarIcon } from './car.svg'
import { ReactComponent as RingIcon } from './ring-notification2.svg'
import { ReactComponent as NavbarHome } from './navbarHome.svg'
import { ReactComponent as NavbarSchedule } from './navbarSchedule.svg'
import { ReactComponent as NavbarNotification } from './navbarNotification.svg'
import { ReactComponent as NavbarProfileCircle } from './navbarProfileCircle.svg'
import { ReactComponent as SummaryCommission } from './summaryCommission.svg'
import { ReactComponent as L2dkdk } from './L2dkdk.svg'
import { ReactComponent as L2ghdk } from './L2ghdk.svg'
import { ReactComponent as L2trambd } from './L2trambd.svg'
import { ReactComponent as Contact } from './contact.svg'
import { ReactComponent as L2cuuho } from './L2cuuho.svg'
import { ReactComponent as L2dkxc } from './L2dkxc.svg'
import { ReactComponent as L2garage } from './L2garage.svg'
import { ReactComponent as L2ghbhtnds } from './L2ghbhtnds.svg'
import { ReactComponent as L2hangbh } from './L2hangbh.svg'
import { ReactComponent as L2hoclaixe } from './L2hoclaixe.svg'
import { ReactComponent as L2hoptx } from './L2hoptx.svg'
import { ReactComponent as L2Khamsklaixe } from './L2Khamsklaixe.svg'
import { ReactComponent as L2muabanxe } from './L2muabanxe.svg'
import { ReactComponent as L2showroom } from './L2showroom.svg'
import { ReactComponent as L2ttdk } from './L2ttdk.svg'
import { ReactComponent as L2tvcaitaoxe } from './L2tvcaitaoxe.svg'
import { ReactComponent as L2muabanxecu } from './L2muabanxecu.svg'
import { ReactComponent as L2hometrafficontrol } from './L2hometrafficontrol.svg'
import { ReactComponent as L2Chamsocxe } from './L2chamsocxe.svg'
import { ReactComponent as L2Ruaxe } from './L2ruaxe.svg'

export const TTDK_THEME = {
  bookingIcon: <BookingIcon />,
  instructionIcon: <InstructionIcon />,
  moreIcon: <MoreIcon />,
  stationIcon: <StationIcon />,
  homeCool: <HomeCool />,
  homeAdvise: <HomeAdvise />,
  homeRescue: <HomeRescue />,
  BHTNDSIcon: <BHTNDSIcon />,
  BagIcon: <BagIcon />,
  LockIcon: <LockIcon />,
  ShieldIcon: <ShieldIcon />,
  UserIcon: <UserIcon />,
  BookingHistoryIcon: <BookingHistoryIcon />,
  VihcleIcon: <VihcleIcon />,
  FileIcon: <FileIcon />,
  CustomerCareIcon: <CustomerCareIcon />,
  BackUpIcon: <BackUpIcon />,
  Feed: <Feed />,
  Pay: <Pay />,
  VihcleIcon2: <VihcleIcon2 />,
  InspectionFeeIcon: <InspectionFeeIcon />,
  RoadFeeIcon: <RoadFeeIcon />,
  InsuranceIcon: <InsuranceIcon />,
  NotifiBlueIcon: <NotifiBlueIcon />,
  CarIcon: <CarIcon />,
  RingIcon: <RingIcon />,
  ContractIcon: <ContractIcon />,
  NavbarHome: <NavbarHome />,
  NavbarSchedule: <NavbarSchedule />,
  NavbarNotification: <NavbarNotification />,
  NavbarProfileCircle: <NavbarProfileCircle />,
  SummaryCommission: <SummaryCommission />,
  L2dkdk: <L2dkdk />,
  L2ghdk: <L2ghdk />,
  L2trambd: <L2trambd />,
  Contact: <Contact />,
  L2cuuho: <L2cuuho />,
  L2dkxc: <L2dkxc />,
  L2garage: <L2garage />,
  L2ghbhtnds: <L2ghbhtnds />,
  L2hangbh: <L2hangbh />,
  L2hoclaixe: <L2hoclaixe />,
  L2hoptx: <L2hoptx />,
  L2Khamsklaixe: <L2Khamsklaixe />,
  L2muabanxe: <L2muabanxe />,
  L2showroom: <L2showroom />,
  L2ttdk: <L2ttdk />,
  L2tvcaitaoxe: <L2tvcaitaoxe />,
  L2muabanxecu: <L2muabanxecu />,
  L2hometrafficontrol: <L2hometrafficontrol />,
  L2Chamsocxe: <L2Chamsocxe />,
  L2Ruaxe: <L2Ruaxe />
}
